import React from 'react'
import PropTypes from 'prop-types'

import Error from './form-input-error'
import IconLoading from '../icon/loading'

import Label from '../label'

import './form-switch-async.styl'

let SWITCH_ASYNC_ID = 0;
class SwitchAsync extends React.Component {

    constructor(props) {
        super(props)
        this.state = {}
        this.id = SWITCH_ASYNC_ID++;
    }

    handleChange(e){
        e.preventDefault();
        let { name, disabled=false } = this.props;
        if(disabled) return

        this.setState({loading: true});
        this.props.onChange(name).then(
            () => this.setState({checked: !this.state.checked, loading: false}),
            () => {
                this.setState({checked: this.state.checked, loading: false, error:true})
                setTimeout(() => this.setState({error: false}), 3000);
            });
    }

    render() {
        let { label, subLabel, disabled, checked=false } = this.props;
        let { labelError } = this.props;
        let { loading=false, error=false } = this.state;

        checked = checked || this.state.checked

        return (<div className={'form form-switch form-switch-async' + (disabled ? ' disabled' : '') }>
            <Label>{label}</Label>
            <div className={'form-switch-button' + (error?' error':'')} htmlFor={'switch-async-button-' + this.id}>
                {!error && <div>
                    <label className={!checked ? 'unchecked' : ''} htmlFor={'switch-async-button-' + this.id}>
                        <Label>{subLabel + '.off'}</Label>
                    </label>

                    <input className="form-switch-button-input"
                           checked={checked}
                           id={'switch-async-button-' + this.id}
                           onChange={this.handleChange.bind(this)}
                           type="checkbox" />

                    <div className={'form-switch-button-onOff' + (checked ? ' checked' : ' unchecked')}  onClick={this.handleChange.bind(this)}>
                        { loading && <IconLoading type="bars" />}
                        { !loading && <div className={'form-switch-button-icon' + (checked ? ' checked' : '')} ></div>}
                    </div>

                    <label className={checked ? 'checked' : ''} htmlFor={'switch-async-button-' + this.id}>
                        <Label>{subLabel + '.on'}</Label>
                    </label>
                </div>}

                { error && <Error visible={error} message={labelError} />}
            </div>
        </div>)
    }
}

SwitchAsync.propTypes = {
    label: PropTypes.string,
    subLabel: PropTypes.string,
    labelError: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
}

SwitchAsync.defaultProps = {
    labelError: 'app.error',
    subLabel: 'app',
    disabled: false
}


export default SwitchAsync;
